var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
// Material ui Imports
import { Typography } from "@mui/material";
//---------------------------------------------------------------------------------------------------
// ## COMPONENTS ##
// VTTypography to display text
export default function VTTypography(_a) {
    var align = _a.align, children = _a.children, gutterBottom = _a.gutterBottom, noWrap = _a.noWrap, paragraph = _a.paragraph, sx = _a.sx, type = _a.type;
    //-------------------------------------------------------------------------------------------------
    // ## CUSTOM FUNCTIONS ##
    function headingSwitch(param) {
        switch (param) {
            case "Heading1":
                return "h3";
            case "Heading2":
                return "h4";
            case "Heading3":
                return "h5";
            case "Heading4":
                return "h6";
            case "Subtitle1":
                return "body1";
            case "Subtitle2":
                return "body2";
            case "Paragraph":
                return "body1";
            default:
                return "inherit";
        }
    }
    //-------------------------------------------------------------------------------------------------
    // ## Render ##
    return (_jsx(Typography, __assign({ align: align, gutterBottom: gutterBottom, noWrap: noWrap, paragraph: paragraph, sx: sx, variant: type ? headingSwitch(type) : "inherit" }, { children: children })));
}
